import React, { useEffect, useState } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";
import { BsCheckLg, BsExclamationCircleFill } from "react-icons/bs";
import { getProgramPoint } from "../../../actions/auth";
import { getVoucherTemplateByMerchantCode } from "../campaigns/services";
import { decrypt } from "../../../utils/encodingdecoding";
import { starHealthMerchantId } from "../../../utils";

const RedeemRewardsModal = (props) => {
  const {
    show,
    close,
    totalAvailableValue,
    handleRedeemApi,
    handleChange,
    error,
    successMsg,
    disable,
  } = props;
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState();
  const [options, setOptions] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [redeemValue, setRedeemValue] = useState("");
  const [selectedTemplateCode, setSelectedTemplateCode] = useState("");

  useEffect(() => {
    const getMinimumPoint = async () => {
      try {
        setLoader(true);
        let token = await JSON.parse(localStorage.getItem("token_gen"));
        const response = await getProgramPoint(token?.access_token);
        const rewards = await getVoucherTemplateByMerchantCode(
          token.access_token,
        );
        const allTemplates = rewards?.data || [];

        const activeTemplates = allTemplates.filter(
          (t) => t.isActive !== false,
        );
        const formattedTemplates = activeTemplates.map((template) => ({
          label: template.name,
          value: Number(template.voucherValue),
          code: template.code,
        }));
        setOptions(formattedTemplates);
        setTemplates(activeTemplates);
        setState(
          response?.data[0]?.transactionPorcessingSettings.minimumRedeemValue,
        );
        setLoader(false);
      } catch (err) {
      } finally {
        setLoader(false);
      }
    };
    getMinimumPoint();
  }, []);

  const renderError = () =>
    error ? (
      <div
        className="alert alert-danger d-flex align-items-center gap-2 border-0 border-start border-4 border-danger rounded-3 small mt-3 mb-0 py-2 px-3"
        role="alert"
      >
        <BsExclamationCircleFill size={18} className="flex-shrink-0" />
        <span>{error}</span>
      </div>
    ) : null;

  return (
    <>
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <Modal show={show} onHide={close} centered>
        <Modal.Header>
          <Modal.Title className="fs-6 fw-semibold">Redeem Points</Modal.Title>
          <CloseButton onClick={close} variant="black" />
        </Modal.Header>
        <Modal.Body className="position-relative">
          {successMsg ? (
            <div className="d-flex flex-column align-items-center text-center pt-3 pb-2">
              <div className="bg-success bg-opacity-10 rounded-circle p-2 mb-3">
                <div className="bg-success text-white rounded-circle shadow d-flex p-3">
                  <BsCheckLg size={30} />
                </div>
              </div>
              <h5 className="fw-bold text-dark mb-1">Redemption Successful!</h5>
              <p className="text-muted mb-4">{successMsg}</p>
              <Button
                variant="success"
                className="fw-semibold rounded-3 px-5"
                onClick={close}
              >
                Done
              </Button>
            </div>
          ) : decrypt(localStorage.getItem("Id")) === starHealthMerchantId ? (
            <>
              <>
                <label>Select Rewards</label>
                <select
                  className="form-control"
                  value={redeemValue}
                  onChange={(e) => {
                    const selectedValue = Number(e.target.value);

                    const selectedOption = options.find(
                      (opt) => opt.value === selectedValue,
                    );

                    if (selectedOption) {
                      setSelectedTemplateCode(selectedOption.code);
                    } else {
                      setSelectedTemplateCode("");
                    }
                    setRedeemValue(e.target.value);
                    handleChange(
                      {
                        target: {
                          name: "inputRedeemPoints",
                          value: e.target.value,
                        },
                      },
                      state,
                    );
                  }}
                >
                  <option value="">Select Rewards</option>
                  {options.map((opt, index) => (
                    <option key={index} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>

                <label className="mt-2">Redeem Points</label>
                <input
                  type="text"
                  className="form-control"
                  value={redeemValue}
                  readOnly
                />

                {renderError()}
              </>
            </>
          ) : (
            <>
              <label>Redeem Points</label>
              <input
                type="text"
                className="form-control"
                maxLength={totalAvailableValue.toString().length}
                name="inputRedeemPoints"
                defaultValue={totalAvailableValue}
                onChange={(e) => handleChange(e, state)}
              />
              {renderError()}
            </>
          )}
        </Modal.Body>
        {!successMsg && (
          <Modal.Footer>
            <Button
              onClick={() => handleRedeemApi(templates, selectedTemplateCode)}
              disabled={
                decrypt(localStorage.getItem("Id")) === starHealthMerchantId
                  ? selectedTemplateCode
                    ? false
                    : true
                  : disable
                    ? true
                    : false
              }
            >
              Redeem Points
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default RedeemRewardsModal;
